import React from 'react'

function FullPageLoader() {
    return (
        <>
            <div className="full-loader-container">
                <div className="full-loader"></div>
            </div>
        </>
    )
}

export default FullPageLoader